/**
 * The short label shown next to a player's name — "In form", "Struggling".
 *
 * Lives here rather than inside a component so the squad list, the matchday
 * picker and anywhere else all describe the same number the same way.
 */
export function formLabel(form) {
  const f = Number(form) || 0;
  if (f >= 0.6) return { text: 'On fire', tone: 'hot' };
  if (f >= 0.2) return { text: 'In form', tone: 'good' };
  if (f <= -0.6) return { text: 'Struggling', tone: 'cold' };
  if (f <= -0.2) return { text: 'Off form', tone: 'meh' };
  return null;
}
